<div  matDialogTitle fxLayout="row" fxLayoutAlign="start center">
		<div>{{ title }}</div>
		<span fxFlex></span>
		<button mat-icon-button matTooltip="Cancel" matDialogClose="cancel" tabindex="-1"><mat-icon>close</mat-icon></button>
</div>
